import { render, staticRenderFns } from "./MessengerIcon.vue?vue&type=template&id=802e3538&scoped=true"
import script from "./MessengerIcon.vue?vue&type=script&lang=js"
export * from "./MessengerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802e3538",
  null
  
)

export default component.exports